import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

const GenericModal = ({
  open,
  onClose,
  Component,
  componentProps = {},
  title,
  titleIcon,
  closeOnBackdrop = true,
  closeOnEsc = true,
  contentProps = {},
  paperSx = {},
  ...dialogProps
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' && !closeOnBackdrop) return;
    if (reason === 'escapeKeyDown' && !closeOnEsc) return;
    if (onClose) onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      sx={{
        zIndex: 50000,
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '& .MuiDialog-paper': {
          width: 'fit-content !important',
          maxWidth: 'unset !important',
          maxHeight: 'calc(100vh - 32px) !important',
          height: 'auto !important',
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          ...paperSx,
        },
        '& .MuiDialogContent-root': {
          padding: 0,
          overflowY: 'auto',
          flex: '1 1 auto',
        },
      }}
      {...dialogProps}>
      {(title || titleIcon || onClose) && (
        <DialogTitle id="generic-modal-title" sx={{ pr: 6, fontWeight: 600, lineHeight: '1', flexShrink: 0 }}>
          {title}
          {titleIcon}
          {onClose && (
            <IconButton aria-label="close" onClick={() => onClose()} sx={{ position: 'absolute', right: 5, top: 5 }}>
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent
        dividers
        sx={{
          p: 0,
          flex: '1 1 auto',
          overflowY: 'auto',
        }}
        {...contentProps}>
        {Component ? <Component {...componentProps} /> : null}
      </DialogContent>
    </Dialog>
  );
};

export default GenericModal;
